import ConnectorsView from "../../../jsx/components/Dashboard/Connectors/ConnectorsView";

const ConnectorsViewWrapper = () => {
  return <ConnectorsView />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.admin];

export default constore(ConnectorsViewWrapper);
